module.exports = __webpack_public_path__ + "static/media/es_ES.7aeabdb2.png";